enum KEY_VALUE_LAYOUT {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical'
}

enum FILTER_LAYOUT {
	inLabel = 'inLabel',
	top = 'top',
	bottom = 'bottom'
}

export { KEY_VALUE_LAYOUT, FILTER_LAYOUT };
